module.exports = __webpack_public_path__ + "img/KZ.1aa0e128.svg";